import React from 'react';

import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper-bundle.css';
import ComunicatoItemPrimoPiano from '#/commons/comunicato/ComunicatoItemPrimoPiano';
import { Button } from '@material-ui/core';
import { DoubleArrow } from '@material-ui/icons';

SwiperCore.use([Pagination]);

class HotNewsSection extends React.Component {

	render() {

		let slidesPerView = 3;

		return (
			<>
				<Swiper
					slidesPerView={slidesPerView}
					pagination={{ clickable: true }}
					className="swiper-news"
					centerInsufficientSlides={true}
					breakpoints={{
						0: {
							slidesPerView: 1,   // mobile
						},
						768: {
							slidesPerView: 2,   // tablet
						},
						1024: {
							slidesPerView: 3,   // desktop
						}
					}}
				>
					{this.props.data?.map((x, idx) => (
						<SwiperSlide key={idx} className="px-3">
							<ComunicatoItemPrimoPiano {...x} />
						</SwiperSlide>
					))}
				</Swiper>
				<div className="text-right mb-2">
					<Button
						variant="contained"
						color="primary"
						className="mr-3"
						endIcon={<DoubleArrow></DoubleArrow>}
						onClick={() => {window.location.href = '/frontoffice/comunicato'}}
						style={{ backgroundColor: "#0c6aaf" }} >
						Archivio
					</Button>
				</div>
			</>
		);
	}
}

export default HotNewsSection;
